import { GrowColumn } from "pages/styles";
import { BracketViewer } from "components/Bracket/BracketViewer";
import { BracketMatchArgs } from "components/Bracket/BracketMatchArgs";
import { Panel } from "components/Panel/Panel";
import { Bracket } from "model/Tournament/Segment/Bracket/Bracket";

interface Props {
  bracket: Bracket;
  tournamentId: string;
}

export const BracketTabContent = ({ bracket, tournamentId }: Props) => {
  return (
    <GrowColumn>
      <Panel padding="padded">
        <BracketViewer
          bracket={bracket}
          tournamentId={tournamentId}
          compact={false}
        />
      </Panel>
    </GrowColumn>
  );
};
